<div class="adminLoginSection">
    <div class="adminLoginBlock">
        <!-- <img src="assets/images/logo.png" alt="" class="adminLogo"> -->
        <form [formGroup]="loginForm" (ngSubmit)="login()">
            <div class="loginSetBox">
                <div class="inputGroup">
                    <input required="true" type="text" formControlName="un" class="inputBox {{loginForm.touched && emailValid.invalid ? 'border-danger' : ''}}" id="uname" placeholder="">
                    <label for="uname" class="inputLabel">Username</label>
                    <span class="passError" *ngIf="loginForm.touched && emailValid.hasError('required')">Please enter username</span>
                    <span class="passError" *ngIf="loginForm.touched && !emailValid.hasError('required') && emailValid.hasError('invalidEmailOrPhone')">Please enter valid username</span>
                </div>
                <div class="inputGroup withIcon" [(ngModel)]="password" *ngIf="!showOTPInput">
                    <div class="imgBlk"><img class="icon"
                            src="{{showPassword ?'assets/images/eye-line.svg' :'assets/images/eye-closed.svg'}}" alt=""
                            (click)="showPassword = !showPassword"></div>

                    <input required="true" type="{{showPassword ?'text' :'password'}}" formControlName="pwd"
                        class="inputBox {{loginForm.touched && passwordValid.invalid ? 'border-danger' : ''}}" id="pass" placeholder="">
                    <label for="pass" class="inputLabel">Password</label>
                    <span class="passError" *ngIf="isFormSubmit && passwordValid.invalid">Please enter password</span>
                </div>
                <div class="btnbx mt-4 text-center">
                    <button type="submit" class="btnTheme active"> Login</button>
                </div>
            </div>
        </form>
    </div>
</div>
